import React from 'react';
import ContentLayout from 'src/components/ContentLayout';
import styles from './styles.module.scss';

const CookiePolicy: React.FC = () => {
  return (
    <ContentLayout size="fullScreen" className={styles['root']}>
      <h1>Соглашение об использовании файлов cookie и иных технических данных</h1>
      <p>
        Настоящим Вы (далее – «Пользователь»), в соответствии с Федеральным законом от 27 июля 2006
        года № 152- ФЗ «О персональных данных» (далее – «Закон 152-ФЗ») свободно, своей волей и в
        своем интересе выражаете свое согласие на обработку файлов сookie и иных технических данных
        (далее – «Данные» и «Согласие» соответственно) при использовании интернет-сайта
        https://sbp.1c.ru, (далее - «Сайт») Закрытому акционерному обществу "ИНФОРАС" (ИНН: 7706249306, 127434,
        г. Москва, ш. Дмитровское, д. 9, этаж 3, комната 63, далее - «Оператор») на следующих условиях:
      </p>
      <table>
        <tbody>
        <tr>
          <td>1</td>
          <td>Способы и средства обработки Данных</td>
          <td>
            Любые действия, допустимые российским законодательством, совершаемые как с
            использованием средств автоматизации включая сбор, запись, систематизацию, накопление,
            хранение, уточнение (обновление, изменение), извлечение, использование, блокирование,
            передача третьим лицам (например, службам аналитики Яндекс, VK, сервисов по
            верификации запросов и блокировке роботов) удаление, уничтожение, в том числе
          </td>
        </tr>
        <tr>
          <td>2</td>
          <td>Перечень обрабатываемых Данных</td>
          <td>
            <ul>
              <li>куки (в т.ч. обязательные, аналитические);</li>
              <li>
                данные о цифровом отпечатке (токен, функциональное описание браузера, часовой
                пояс, и т.д.);
              </li>
              <li>технических данных о Вашем устройстве и IP-адресе;</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>3</td>
          <td>Цель обработки Данных</td>
          <td>
            <ul>
              <li>обеспечение и улучшение функций и работы Сайта;</li>
              <li>
                предоставление информационных предложений для улучшения пользовательского опыта;
              </li>
              <li>обеспечение защиты от хакерских атак (DDoS-атак)</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>4</td>
          <td>Отзыв Согласия</td>
          <td>
            Пользователь может отказаться от обработки Данных, которые носят необязательный
            характер, в настройках своего браузера. При этом отказ от использования необязательных
            Данных может отразиться на пользовательском интерфейсе и некоторых компонентах Сайта.
          </td>
        </tr>
        <tr>
          <td>5</td>
          <td>Политика Оператора в отношении обработки и защиты Данных</td>
          <td>
            <a
              href="https://sbp.1c.ru/ui/privacyPolicy"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://sbp.1c.ru/ui/privacyPolicy
            </a>
          </td>
        </tr>
        <tr>
          <td>6</td>
          <td>Способ предоставления Согласия</td>
          <td>Путем продолжения использования Сайта</td>
        </tr>
        <tr>
          <td>7</td>
          <td>Срок действия Согласия</td>
          <td>
            Согласие Пользователя на обработку ПДн действует с момента подключения к Сайту и до
            достижения заявленных целей обработки или до момента его отзыва.
          </td>
        </tr>
        </tbody>
      </table>
    </ContentLayout>
  );
};

export default CookiePolicy;
